import formComponent from '@/util/proto/formComponent'

export default {
  extends: formComponent,
  data() {
    return {
      formData: {
        cooperatorId: {
          rules: [
            { required: true, type:'number', message: '请选择金融公司', trigger: 'blur,change' },
          ]
        },
        name: {
          rules: [
            { required: true, message: '请输入方案名称', trigger: 'blur,change' },
          ]
        },
        clearingType: {
          rules: [
            { type: 'number', required: true, message: '请选择结算方式', trigger: 'blur,change' },
          ],
        },
        stagesNum: {
          rules: [
            { type: 'number', required: true, message: '请输入每期费用', trigger: 'blur,change' },
          ],
        },
        stagesPrice: {
          rules: [
            { type: 'number', required: false, message: '请输入每期费用', trigger: 'blur,change' },
          ],
        },
        state:null,
        remark:null
      },
      def: {},
      
      id: null,
      loading: false,
      visible: false,
      api:['installmentCreate','installmentUpdate']
    }
  },

  created() {

  },
  computed: {
    itemTitle() {
      return this.id ? '编辑分期方案' : '新增分期方案'
    },
    companies() {
      return this.$request.partnerSelect().then(resp => {
        return Promise.resolve(resp.data.map(i => ({
          value: i.id,
          label: i.cooperatorName,
        })))
      })
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.reset()
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.insurance(this.id).then(resp => {
        this.loading = false
        this.$setFormData(resp.data)
      })
    },
    reset() {
      this.$resetFormData()
    },

    beforeSave(d){
      return d
    }

  },

  render(){
    return  <sl-side-panel v-model={this.visible} loading={this.loading} mask-closable={false} title={this.itemTitle}>
        <sl-form label-width={120}>
          <sl-form-item label="方案名称">
            <Input v-decorator={this.formData.name} maxlength={128}></Input>
          </sl-form-item>
          <sl-form-item label="金融公司">
            <sl-select v-decorator={this.formData.cooperatorId} dict={this.companies} />
          </sl-form-item>
          <sl-form-item label="结算方式">
            <sl-select dict="clearingType" v-decorator={this.formData.clearingType} />
          </sl-form-item>
          <sl-form-item label="分期数">
            <InputNumber min={1} step={1} parser={ v => v.replace(/[^\d]/g, '') } active-change={true} v-decorator={this.formData.stagesNum}></InputNumber>
          </sl-form-item>
          <sl-form-item label="每期费用（元）">
            <InputNumber min={0.01} precision={2} active-change={false}  v-decorator={this.formData.stagesPrice}></InputNumber>
          </sl-form-item>
          <sl-form-item label="状态">
            <sl-select v-decorator={this.formData.state} type="radio" dict="stateN"></sl-select>
          </sl-form-item>
          <sl-form-item label="备注">
            <Input type="textarea" autosize={{minRows: 5,maxRows: 8}} v-decorator={this.formData.remark}></Input>
          </sl-form-item>
        </sl-form>

        <div slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </div>
    </sl-side-panel>
  }
}

